import Swiper, { Autoplay, Keyboard, Navigation, Pagination } from 'swiper';

import { addAssets } from './helpers';

Swiper.use([Autoplay, Keyboard, Navigation, Pagination]);
addAssets({ Swiper });
